import React, { useCallback, useEffect, useMemo, useState } from 'react'

import {CircularProgress, Box, Grid} from '@mui/material'
import { useSelector } from 'react-redux'

import useStyles from '../../styles/global-mui.js';

import { discipline_all, getActualSeason, season_all } from '../../bdd/bddSTUB.js'
import Select_Dsas from '../../dsasComponents/Select_Dsas.js'
import Live from './live/Live.js'
import FilterGroupProvider from '../../dsasComponents/FilterGroupProvider.js'
import { getUserProvider } from '../../actions/auth.js'
import { fetchCompetitions, fetchLives } from '../../api/index.js'
import { useFetch } from '../../filters/useFetch.js'
import DatePicker_Dsas from '../../dsasComponents/DatePicker_Dsas.js'
import Pagination from '../../dsasComponents/pagination/Pagination.js'
import FilterUser from '../../dsasComponents/FilterUser.js'
import { Can } from '../../permissions/Can.js'
import { PERMISSIONS } from '../../permissions/permissionKeys.js'

/**
 * Sport Live page
 * @description Page to display all lives with filters
 * @param {function} setCurrentId - function to set the current id of the live
 * @returns 
 */import { useSearchParams } from 'react-router-dom'
import { usePermissions } from '../../permissions/usePermissions.js';

const Lives = ({ setCurrentId }) => {
    const classes = useStyles();
    const livesCollection = useSelector((state) => state.lives);

    const { getPermission } = usePermissions();
    const providerPermission = getPermission(PERMISSIONS.FILTER_PROVIDER);

    const [searchParams, setSearchParams] = useSearchParams(); // ✅ Hook pour gérer les query params

    // 🛠️ Initialisation des filtres à partir de l'URL (sinon valeurs par défaut)
    const initialFilters = {
        discipline: searchParams.get("discipline") || "",
        competition: searchParams.get("competition") || "",
        provider: searchParams.get("provider") || getUserProvider(),
        userNames: searchParams.get("userNames") || "",
        season: searchParams.get("season") || getActualSeason(),
        startDate: searchParams.get("startDate") ? new Date(searchParams.get("startDate")) : new Date(),
        endDate: searchParams.get("endDate") ? new Date(searchParams.get("endDate")) : new Date(),
        matchs: { $ne: [] }
    };

    const [filters, setFilters] = useState(initialFilters);

    // ✅ Mettre à jour l'URL quand `filters` change
    useEffect(() => {
        // Filters change d'instance
        setSearchParams({
            ...filters,
            startDate: filters.startDate.toISOString().split("T")[0], // 🔄 Format YYYY-MM-DD
            endDate: filters.endDate.toISOString().split("T")[0],
        });
    }, [filters]);

    const [lives, loading] = useFetch(fetchLives, filters, ["startDate", "endDate"], "FETCH_ALL_LIVE");
    const [competitions, loadingCompetition] = useFetch(fetchCompetitions, filters, undefined, "FETCH_ALL_COMPETITION");

    const livesNoDoublon = useMemo(() => {
        const livesCollectionFiltered = livesCollection.filter(live => !lives.find(l => l._id === live._id));
        return lives.concat(livesCollectionFiltered);
    }, [livesCollection, lives]);

    const handleUserFilter = useCallback((user) => {
        return filters.provider === user.provider;
    }, [filters.provider]);

    return (
        loading ? <CircularProgress /> : (<>

            {/**FILTERS*/}
            <Box className='padding-wrapper'>
                <Grid container spacing={1.5} sx={{alignItems : 'flex-end'}}>
                    {providerPermission?.allowed && ( 
                    <Grid item xs={12} sm={12} md>
                        {/* Groupe (Provider) */}
                        <FilterGroupProvider
                        classname={classes.customInput}
                        labelId = {"provider_label"}
                        label = {"Groupe"}
                        selectId = {"provider"}
                        name = {"provider"}
                        filters = {filters} 
                        setFilters = {setFilters}
                    />             
                    </Grid>
                    )}
                    <Grid item xs={12} sm={12} md>
                        {/* User */}
                        <FilterUser
                        classname={classes.customInput}
                        labelId = {"users_label"}
                        label = {"Utilisateur"}
                        selectId = {"userNames"}
                        name = {"userNames"}
                        filters = {filters} 
                        setFilters = {setFilters}
                        handleFilter = {handleUserFilter}
                    />
                    </Grid>
                    <Grid item xs={12} sm={12} md>
                        {/* Discipline */}
                        <Select_Dsas
                            className={classes.customInput}
                            labelId = {"discipline_label"}
                            label = {"Discipline"}
                            selectId = {"discipline"}
                            name = {"discipline"}
                            value = {filters.discipline}
                            items = {discipline_all}
                            onChange = {(e) => setFilters(state => ({...state, discipline : e.target.value}))}
                            onReset = {(e) => setFilters(state => ({...state, discipline : ''}))}
                        />             
                    </Grid>
                    <Grid item xs={12} sm={12} md>
                        {/* Season */}
                        <Select_Dsas
                            className={classes.customInput}
                            labelId = {"season_label"}
                            label = {"Saison"}
                            selectId = {"season"}
                            name = {"season"}
                            value = {filters.season}
                            items = {season_all}
                            onChange = {(e) => setFilters(state => ({...state, season : e.target.value}))}
                            onReset = {(e) => setFilters(state => ({...state, season : ''}))}
                        />             
                    </Grid>
                    <Grid item xs={12} sm={12} md>
                        {/* Competition */}
                        <Select_Dsas
                            className={classes.customInput}
                            labelId = {"competition_label"}
                            label = {"Compétition"}
                            selectId = {"competition"}
                            name = {"competition"}
                            value = {filters.competition}
                            items = {competitions}
                            onChange = {(e) => setFilters(state => ({...state, competition : e.target.value}))}
                            onReset = {(e) => setFilters(state => ({...state, competition : ''}))}
                        />            
                    </Grid>
                </Grid>
            </Box>
            <Box className='medium-separator'></Box>
            <Box className='small-padding'></Box>
            <Box className='padding-wrapper'>
                <Grid container spacing={1.5} sx={{alignItems : 'center'}}>
                    <Grid item className='centered-wrapper' sx={{justifyItems: 'center'}} xs={12} sm md>
                        {/* Begin date */}
                        <DatePicker_Dsas
                        className={classes.customInput}
                        label={"Début"}
                        name={"startDate"}
                        value={filters.startDate}
                        onChange = {(value) => setFilters(state => ({...state, startDate : value}))}
                        isBorder={false}
                        />             
                    </Grid>
                    <Grid item className='centered-wrapper' sx={{justifyItems: 'center'}} xs={12} sm md>
                        {/* End date */}
                        <DatePicker_Dsas
                        className={classes.customInput}
                        label={"Fin"}
                        name={"endDate"}
                        value={filters.endDate}
                        onChange = {(value) => setFilters(state => ({...state, endDate : value}))}
                        isBorder={false}
                        />
                    </Grid>
                </Grid>
            </Box>
            <Box className='small-padding'></Box>
            <Box className='medium-separator'></Box>

            <Box className='padding-wrapper'>
                {/**RESULTS*/}
                {livesNoDoublon?.length>0 && 
                    <Pagination items={livesNoDoublon} classes={classes} type='Directs' className={classes.customTablePagination}>
                        {livesNoDoublon.map(live => 
                            <Live live={live} setCurrentId={setCurrentId} reload={() => setTimeout(() => setFilters({...filters}), 200)}/>
                        )}
                    </Pagination>
                }
            </Box>    
        </>
        )
    );
};

export default Lives